import { render, staticRenderFns } from "./EditListModal.vue?vue&type=template&id=3640e646&"
import script from "./EditListModal.vue?vue&type=script&lang=js&"
export * from "./EditListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports